import { NB } from '@cerebral-inc/ui';
import { BasicSpinner } from 'components/shared/spinner';

const { Flex, Text } = NB;

export interface CreatingScoreProps {
  loadingText: string;
}

const CreatingScore = ({ loadingText }: CreatingScoreProps) => {
  return (
    <>
      <Flex
        minH="calc(100dvh - 189px)"
        px="24px"
        justifyContent="center"
        alignItems="center"
      >
        <Flex maxW={{ base: '100%', sm: '480px' }}>
          <BasicSpinner />
          <Text
            color="#1C1E21"
            fontSize="22px"
            fontWeight={600}
            lineHeight="24px"
            mt="32px"
            textAlign="center"
          >
            Analyzing your responses
          </Text>
          <Text
            color="#353A41"
            fontSize="16px"
            lineHeight="24px"
            textAlign="center"
            mt={2}
          >
            {loadingText}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default CreatingScore;
